module.exports = "https://tutorchat.chegg.com/static/media/avatar-chegg.0c537f2b.svg";